'use client';
import { PropsWithChildren } from 'react';
import useIsMobile from '../utils/useIsMobile';

type Props = {
  initIsMobile?: boolean;
  viewport: 'mobile' | 'desktop' | 'm' | 'd';
  condition?: boolean;
};

const OptionalViewport = ({
  children,
  viewport,
  condition,
  initIsMobile,
}: PropsWithChildren<Props>) => {
  const isMobile = useIsMobile(initIsMobile);
  if (['mobile', 'm'].includes(viewport) && !isMobile) return null;
  if (['desktop', 'd'].includes(viewport) && isMobile) return null;
  if (typeof condition === 'boolean' && !condition) return null;
  return children;
};

export default OptionalViewport;
